<script>
import axios from "axios";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import ModalDetailProgress from "./modal/modal-detail-progress.vue";
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  components: { Datatable, Pagination, ModalDetailProgress },
  props: {
    idJadwal: { type: [String, Number], required: true },
  },
  data() {
    return {
      isLoading: false,
      column: [
        { label: "Batch", name: "batch" },
        { label: "Total Peserta", name: "total_peserta" },
        { label: "Progress Peserta", name: "progress_peserta" },
        { label: "Persentase", name: "persentase_batch" },
        { label: "Aksi", name: "aksi", class: "text-center" },
      ],
      pagination: {},
      tableFilter: {
        page: 1,
        per_page: 10,
        batch: "",
      },
      tableData: [],
      showDetailModal: false,
      selectedBatch: null,
      optionFilterBatch: [], 
    };
  },
  mounted() {
    this.getData();
    this.getFilterBatch();
    this.filterBatch = _.debounce(this.searchBatch.bind(this), 500);
  },
  methods: {
    async getFilterBatch(search = "", loading) {
      if(loading) loading(true);
      await axios({
        method: "get",
        url:
          `${process.env.VUE_APP_BACKEND_URL_VERSION}referensi/jadwal-batch/all`,
        params: { search: search, limit: 10, id_jadwal: this.idJadwal },
        headers: { Authorization: "Bearer " + localStorage.access_token },
      }).then((response) => {
        this.optionFilterBatch = response.data.data;
        if (loading) loading(false);
      });
    },
    async searchBatch(search, loading) {
      if (search.length) {
        this.getFilterBatch(search, loading);
      }
    },
    async getData() {
      this.isLoading = true;
      try {
        const authToken = localStorage.access_token;
        const url = `${process.env.VUE_APP_BACKEND_URL_VERSION}master/jadwal-pelaksanaan/progress-batch/${this.idJadwal}`;

        const response = await axios.get(url, {
          params: this.tableFilter,
          headers: { Authorization: `Bearer ${authToken}` },
        });
        
        const data = response.data.data;
        this.tableData = data.data;
        this.pagination = data;
      } catch (error) {
        console.error("Error fetching progress batch:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleDetailClick(batchData) {
      this.selectedBatch = batchData.batch;
      this.showDetailModal = true;
    },
    async handleExport() {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Mempersiapkan file...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      try {
        const authToken = localStorage.access_token;
        const url = `${process.env.VUE_APP_BACKEND_URL_VERSION}export-excel/${this.idJadwal}/progress-batch`;

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${authToken}` },
          responseType: 'blob',
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'export-progress.xlsx';
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch.length === 2)
                fileName = fileNameMatch[1];
        }

        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
        fileLink.remove();
        window.URL.revokeObjectURL(fileURL);
        Swal.close();

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Gagal Mengunduh",
          text: "Terjadi kesalahan saat mencoba mengunduh file.",
        });
        console.error("Export error:", error);
      }
    },
    toPage(url) {
      if (url) {
        let link = new URLSearchParams(url.split("?")[1]);
        this.tableFilter.page = link.get("page");
        this.getData();
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="card-title">Progress Batch Jadwal Pelaksanaan</div>
      </div>
      <div class="col-6 text-end">
        <button class="btn btn-success btn-sm" @click="handleExport">
            <i class="fa fa-file-excel me-1"></i> Export Excel
        </button>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="form-group col-md-4 mb-2">
        <label for="filterBatchProgress">Filter Batch</label>
        <v-select
          id="filter_batch_progress"
          class="style-chooser"
          :options="optionFilterBatch"
          :reduce="(batch) => batch.nama_batch"
          label="nama_batch"
          v-model="tableFilter.batch"
          placeholder="Pilih Batch"
          @search="filterBatch"
          @clear="getData"
          v-on:update:model-value="getData"
        />
      </div>
    </div>
    <hr />

    <table class="mb-2">
      <tr>
        <td>Show</td>
        <td>
          <select
            class="form-control form-control-sm"
            v-model="tableFilter.per_page"
            @change="getData()"
          >
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
          </select>
        </td>
        <td>Entries</td>
      </tr>
    </table>

    <Datatable :columns="column">
        <tbody>
            <tr v-if="isLoading">
                <td colspan="5" class="text-center">
                    <i class="fa fa-spinner fa-spin"></i> Loading...
                </td>
            </tr>
            <tr v-else-if="!tableData.length">
                <td colspan="5" class="text-center">Data tidak ditemukan</td>
            </tr>
            <tr v-else v-for="(row, index) in tableData" :key="index">
                <td>{{ row.batch }}</td>
                <td>{{ row.total_peserta }}</td>
                <td>{{ row.progress_peserta }}</td>
                <td>{{ row.persentase_batch }}</td>
                <td class="text-center">
                    <button class="btn btn-primary btn-sm" @click="handleDetailClick(row)">
                        Detail
                    </button>
                </td>
            </tr>
        </tbody>
    </Datatable>
    <pagination :pagination="pagination" @to-page="toPage"></pagination>

    <b-modal
      v-model="showDetailModal"
      hide-footer
      title="Detail Progress Peserta"
      size="xl"
      scrollable
      centered
    >
      <ModalDetailProgress
        v-if="showDetailModal"
        :id-jadwal="idJadwal"
        :nama-batch="selectedBatch"
      />
    </b-modal>
  </div>
</template>